import { render, staticRenderFns } from "./CreatePaymentGeneralKasbon.vue?vue&type=template&id=7a80c390"
import script from "./CreatePaymentGeneralKasbon.vue?vue&type=script&lang=js"
export * from "./CreatePaymentGeneralKasbon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports